import { render, staticRenderFns } from "./editCarNewCard.vue?vue&type=template&id=bb780158"
import script from "./editCarNewCard.vue?vue&type=script&lang=js"
export * from "./editCarNewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports